import { useMemo } from "react";
import Card, { Bar } from "./Card.jsx";
import { getParityStats } from "../../lib/lotto.js";

export default function Parity({ rows }) {
  const stats = useMemo(() => getParityStats(rows), [rows]);
  const { distribution, oddRatio, evenRatio } = stats;
  const max = Math.max(...distribution);

  return (
    <Card
      title="홀짝 분포"
      subtitle={`홀 ${(oddRatio * 100).toFixed(1)}% · 짝 ${(evenRatio * 100).toFixed(1)}%`}
      span={1}
    >
      {distribution.map((count, k) => (
        <Bar
          key={k}
          value={count}
          max={max}
          label={`홀 ${k} : 짝 ${6 - k}`}
          highlight={k === 3 || k === 4}
        />
      ))}
    </Card>
  );
}
